import { render, staticRenderFns } from "./Steps4IdeaWriter.vue?vue&type=template&id=b5e06b22&scoped=true"
import script from "./Steps4IdeaWriter.vue?vue&type=script&lang=js"
export * from "./Steps4IdeaWriter.vue?vue&type=script&lang=js"
import style0 from "./Steps4IdeaWriter.vue?vue&type=style&index=0&id=b5e06b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e06b22",
  null
  
)

export default component.exports